/**
 *   @description 配置文件
 *   @author Xiaohui Zeng
 *   @date 2019/10/5
 */
// 默认首页
// export const siteTitle = localStorage.getItem('infoMsg') && JSON.parse(localStorage.getItem('infoMsg')) && JSON.parse(localStorage.getItem('infoMsg')).companyName ? localStorage.getItem('infoMsg') && JSON.parse(localStorage.getItem('infoMsg')) && JSON.parse(localStorage.getItem('infoMsg')).companyName : 'e航无忧'
export const siteTitle = ''//'e航无忧'
// 默认首页
export const indexPage = 'home' // home
// 默认登录页
export const loginPage = 'register'

// 主题风格
export const themeData = {
    themeType: 'dark', // 主题风格配置 dark(经典酷黑) 或者 light(极简雅白) 默认dark经典酷黑
    isTabsShow: false, // 是否显示多页签 默认true
    headMaxWidth: false // 栏目头部是否通顶（最大宽度） 默认false
}

// oss地址
export const ossUrl = 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com'
